import "./style.css"
import {Route, Routes} from "react-router-dom"
import MapperHome from "./app-mapper/homepage/MapperHome"
import ProjectDetails from "./app-mapper/stats/ProjectDetails"
import FieldsList from "./app-mapper/fields/FieldsList"
import FieldMap from "./app-mapper/fields/FieldMap"
import FieldsListSrcUsage from "./app-mapper/fields/FieldsListSrcUsage"
import FeaturesList from "./app-mapper/features/FeatsList"
import FeatureMap from "./app-mapper/features/FeatMap";
import ValuesList from "./app-mapper/features/ValsList";
import ProjectTopNav from "./app-mapper/_subcomponents/ProjectTopNav";
import Login from './pages/Login'
import PrivateRoutes from "./helpers/PrivateRoutes";
import {AuthProvider} from "./context/AuthContext";
import Sandbox from "./pages/Sandbox";
import Main from "./pages/Main"
import ScriptsHome from "./app-scripts/ScriptsHome"
import TemplatesList from "./app-mapper/templates/TemplatesList";
import ProdsList from "./app-mapper/products/ProdsList";
import ProdDetails from "./app-mapper/products/ProdDetails";
import TemplateMap from "./app-mapper/templates/TemplateMap";
import ReportsTopNavBar from "./app-reports/_components/ReportsTopNavBar"
import FullTaxGrid from "./app-reports/full_taxonomy/FullTaxGrid"
import DownloadsHome from "./app-reports/downloads/DownloadsHome";
import FeatsListSrcUsage from "./app-mapper/features/FeatsListSrcUsage";
import Page404 from "./pages/404";
import ReportsMain from "./app-mapper/reports/ReportsMain"


export default function App() {

    return (

        <>
            <AuthProvider>

                <Routes>
                    <Route path='*' element={<Page404 />}/>

                    <Route path="/sandbox" element={<Sandbox/>}/>
                    <Route path="/login" element={<Login/>}/>

                    <Route element={<PrivateRoutes/>}>

                        {/*<Route path="" element={<Main/>}/>*/}
                        <Route path="/" element={<Main/>}/>


                        <Route path="mapper">

                            <Route path="projects/:page_num" element={<MapperHome/>}/>

                            <Route path="templates">
                                <Route path=":page_num" element={<TemplatesList/>}/>
                                <Route path="detail/:tmpl_pk" element={<TemplateMap/>}/>
                            </Route>

                            <Route path="prj/:prjid" element={<ProjectTopNav/>}>

                                {/*<Route index />*/}

                                <Route path="details" element={<ProjectDetails/>}/>

                                {/* Fields: categories, brands, families etc. */}
                                <Route path="fields">
                                    <Route path=":page_num/" element={<FieldsList/>}/>
                                    <Route path="map/:field_pk/:usemap?" element={<FieldMap/>}/> {/* target map */}
                                    <Route path=":field_pk/srcusage" element={<FieldsListSrcUsage/>}/>    {/* src feats usage */}
                                </Route>

                                {/* Features */}
                                <Route path="feats">
                                    <Route path=":page_num/" element={<FeaturesList/>}/>
                                    <Route path="map/:cat_pk/:feat_pk/:val_pk/" element={<FeatureMap/>}/> {/* target map */}
                                    <Route path=":cat_pk/:feat_pk/values/:page_num" element={<ValuesList/>}/>    {/* src or trg */}
                                    <Route path=":cat_pk/:feat_pk/srcusage" element={<FeatsListSrcUsage/>}/>    {/* src feats usage */}
                                </Route>

                                {/* Products/Feeds */}
                                <Route path="prods">
                                    <Route path=":page_num" element={<ProdsList/>}/>
                                    <Route path="details/:prod_id" element={<ProdDetails/>}/>
                                </Route>

                                {/* Reports */}
                                <Route path="reports" element={<ReportsMain/>}/>

                            </Route>

                        </Route>


                        {/* OLD NOT IN USE PAGES */}
                        <Route path="reports_tax" element={<ReportsTopNavBar/>}>
                            <Route path="" element={<DownloadsHome/>}/>
                            <Route path="fulltax/:page_num" element={<FullTaxGrid/>}/>
                        </Route>

                        <Route path="scripts">
                            <Route index/>
                            <Route path="" element={<ScriptsHome/>}/>
                        </Route>

                    </Route>


                </Routes>

            </AuthProvider>
        </>

    )
}


// export default function App() {
//     const [siteData, setSiteData] = useState<SiteData>({
//         currentPage: 'home',
//         breadcrumb: [],
//         // modal: {openState: false}
//     });
//
//     return (siteData.currentPage !== 'waiting') ? (
//         (siteData.user?.email || true) ? (
//             <PrivateRoute siteData={siteData} setSiteData={setSiteData} /> // & authService={authService}
//         ) : (
//             // <Login siteData={siteData} setSiteData={setSiteData} authService={authService}/>
//             <div>Login</div>
//         )
//     ) : (<div>Waiting</div>)
//
// }


// export default function App() {
//
//     const sampleTargetFeature: FaceTargetFeature = {
//         categoryID: "30016699",
//         categoryName: "Poppenhuisen",
//         featureID: "App Works on Operating System",
//         featureName: "App werkt op besturingssyteem",
//         featureType: "dropdown",
//         featureUnit: "mm",
//         featureValues: ['AIB', 'ASTM', 'CE', 'CPSIA section 101(a)(2)', 'EN 14619', 'EN 16401', 'EN 62115', 'EN 71', 'EN 71 1-3', 'EN13899', 'EN72', 'EN73', 'EN74', 'EN76', 'GOTS', 'HR4040', 'LGA', 'Oeko-tex standard 100', 'Rohs', 'SGS', 'TuV', 'geen kwaliteitslabel'],
//         // featureValues: [],
//         featureMulti: "Y",
//         featureStatus: "Mandatory"
//     }
//
//     return (
//         <div>
//             <TargetFeature featureObj={sampleTargetFeature}/>
//
//             <div className="settings-container">
//                 <SourceCats/>
//                 <MapSettings/>
//             </div>
//
//             <FullMapping values={sampleTargetFeature.featureValues}/>
//
//         </div>
//     );
// }


